import { ErrorCodes } from "../constants/errorCodes";

const init = (options) => {
    const keys = ["tag"];

    keys.forEach((key) => {
        if (!options[key]) throw ErrorCodes[key];
    });

    return { isInitialized: true };
};

const initiateSdk = (data) => {
    if (data.tag) {
        const elById = document.getElementById(data.tag);
        const elByName = document.getElementsByName(data.tag).length;
        if (!elById && elByName === 0) throw ErrorCodes.tagNotFound;
    }

    return true;
};

export default {
    init,
    initiateSdk,
};
